import { Controller } from '@hotwired/stimulus'
import { createConsumer } from '@rails/actioncable'

export default class extends Controller {
  static values = {
    accountId: String,
    userId: String
  }

  get subscriptionParams() {
    const channel = 'EmissionFactorsChannel'
    return {
      channel: channel,
      user_id: this.userIdValue,
      account_id: this.accountIdValue
    }
  }

  connect() {
    this.suscribeToEmissionFactorsChannel()
  }

  suscribeToEmissionFactorsChannel() {
    createConsumer().subscriptions.create(this.subscriptionParams, {
      received(data) {
        this.handleChannelBroadcast(data)
      },

      handleChannelBroadcast(data) {
        const event = data.event
        const afterSubmitPath = data.after_submit_path
        switch (event) {
          case 'success':
            this.handleEmissionFactorsSuccess(afterSubmitPath)
            break
        }
      },
      handleEmissionFactorsSuccess(afterSubmitPath) {
        window.location.href = afterSubmitPath
      }
    })
  }
}
